import {IKnockoutComponent, TBaseOrObservableOrFunctionArrayType, TBaseOrObservableOrFunctionType} from "../../index";
import {ISplitButtonParams} from "@component/button/splitButton/split-button";

type TGetter<T, R = any> = (obj: T) => R

type TKey<T> = keyof T

type TValue<T> = TKey<T> | any

interface ITableDef<T> {
    checkbox?: ITableCheckboxDef | true
    columns: TBaseOrObservableOrFunctionArrayType<ITableColumnDef<T>>
    data: TBaseOrObservableOrFunctionArrayType<T>
    header?: ITableColumnHeader<T>
    navigation?: ITableNavigation | boolean
    rows?: ITableRowDef<T>
    searchkey?: KnockoutObservable<string | null> | KnockoutComputed<string | null>
    selected?: KnockoutObservableArray<T>
    sort?: ITableSortDef<T> | true
    translationKey: string
    operationsButton?: ISplitButtonParams;
}

interface ITableColumnDef<T> {
    buttons?: TBaseOrObservableOrFunctionArrayType<ITableButton<T>>
    contentType?: 'text' /* default */ | 'html' | 'component'
    getComponent?: (obj: T, col: ITableColumnDef<T>, val: TValue<T>) => IKnockoutComponent
    getContent?: (obj: T, col: ITableColumnDef<T>, val?: TValue<T>) => any
    getSearchMarkup?: ((obj: T, col: ITableColumnDef<T>, val?: TValue<T>) => string) | false
    getSortValue?: TGetter<T, string | number | boolean>
    getTitle?: TGetter<T, string>
    header?: ITableColumnHeader<T>
    key: TKey<T>
    label?: string
    searchable?: TBaseOrObservableOrFunctionType<boolean> // whether to show the cell's content
    show?: (obj: T, col: ITableColumnDef<T>, val: TValue<T>) => boolean
    sortable?: TBaseOrObservableOrFunctionType<boolean> // whether to show the column
    validate?: () => boolean
}

interface ITableCheckboxDef {
    validate?: TBaseOrObservableOrFunctionType<boolean>
}

interface ITableRowDef<T> {
    checkbox?: IRowCheckboxDef<T>
    getTitle?: TGetter<T, string>
    onClick?: TGetter<T, boolean | void>
    getAttr?: TGetter<T,  any>
}

interface IRowCheckboxDef<T> {
    isChecked: TGetter<T, boolean>
    onToggle: TGetter<T, void>
    show?: TGetter<T, boolean>
    validate?: () => boolean
}

interface ITableSortDef<T> {
    ascending?: KnockoutObservable<boolean>
    sortColumn?: KnockoutObservable<keyof T>
}

interface ITableNavigation {
    data?: TBaseOrObservableOrFunctionArrayType<any>
    getNavComponent?: () => IKnockoutComponent
    pagenr?: KnockoutObservable<number>
    totalresults?: KnockoutObservable<number>
}

interface ITableColumnHeader<T> {
    getContent?: TGetter<ITableColumnDef<T>, string>
    getTitle?: TGetter<ITableColumnDef<T>, string>
}

interface ITableButton<T> {
    getTitle?: TGetter<T, string>
    icon: TBaseOrObservableOrFunctionType<string>
    onClick: TGetter<T, boolean | void>
    validate?: TGetter<T, boolean>
    cls?: string
}